import { useEffect } from "react";
import useFetchJson from "../../../data/useFetchJson";
import { useGetParams } from "../../../utils/useGetParams";
import { Box, Card, Divider, Grid, Stack, Typography } from "@mui/material";
import DlspTaskStatusChip from "../../styled/DlspTaskStatusChip";
import { DlspBreadcrumbs } from "./DlspBreadcrumbs";
import { DebugBox, LoadingBox, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { mahiBffUrl } from "../../../data/hikoFetch";
import { SmallLabelledText } from "../../styled/SmallLabelledText";
import { DlspFieldInspectionForm } from "./DlspFieldInspectionForm";
import UpdatedGalleryViewer from "../../upload/UpdatedGalleryViewer";

const bffBaseUrl = mahiBffUrl()

export default function DlspTaskFieldInspection() {

    const getParams = useGetParams(['icp_number', 'assignee'])
    const navigateToTaskDetails = useNavigateWithParams('/dlsp/task/details')

    const getTaskDetailsPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/get-detail'
    const {
        isLoading: taskDetailsLoading,
        data: taskDetails, // E.g. { decomICP, odsICP, gsICP, odsDSub, statusHistory }
        load: getTaskDetails} = useFetchJson(getTaskDetailsPath, {}, false) 

    const bffGetAllPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/get-all`
    const { data: allImages, load: loadAllImages } = useFetchJson(bffGetAllPath)

    useEffect(() => {
        if (!getParams?.icp_number) {
            return
        }
        const fetchParams = {
            params: {
                icpNo: getParams?.icp_number,
            }
        }
        getTaskDetails(fetchParams, getTaskDetailsPath)

        const imageParams = { params: { icp: getParams?.icp_number } }
        loadAllImages(imageParams) // run in background

    }, [getParams, getTaskDetails, loadAllImages]) 

    const handleClose = () => {
        navigateToTaskDetails({icp_number: getParams?.icp_number, assignee: getParams?.assignee})
    }

    return (
        <Box className="Page">
            <Stack direction="row" sx={{flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between'}}>
                <Box>
                    <h3>Decommissioned Lines Safety Project</h3>
                    <h2>Field Inspection</h2>
                    <h3>{taskDetails?.decomICP?.address}</h3>
                </Box>
                <DlspTaskStatusChip status={taskDetails?.decomICP?.status} statusReason={taskDetails?.decomICP?.assignee} />
            </Stack>

            <Stack direction="row" sx={{mb: 2, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between'}}>
                <DlspBreadcrumbs
                    assignee={getParams?.assignee}
                    stormArea={taskDetails?.decomICP?.stormArea}
                    suburb={taskDetails?.odsDSub?.suburb}
                    taskAddress={taskDetails?.decomICP?.address}
                    taskICPNumber={getParams?.icp_number}
                    assessmentName="Field Inspection"
                />
            </Stack>

            <LoadingBox loading={taskDetailsLoading}>



                {/* <Typography variant="h6" color="secondary" paragraph>Desktop QA</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <SmallLabelledText label="Desktop QA Comments"                    text={taskDetails?.decomICP?.desktopQA?.desktopQAComments} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SmallLabelledText label="Field Inspection Images Required"       text={taskDetails?.decomICP?.desktopQA?.fieldPhotosRequired} />
                    </Grid>
                </Grid> */}

                <Card sx={{p:1}}>
                    <Typography variant="h6" color="secondary" paragraph>Field Inspection</Typography>
                    <DlspFieldInspectionForm
                        icpNumber={getParams?.icp_number}
                        inspectionDetails={taskDetails?.decomICP?.fieldChecklist}
                        fieldPhotosRequired={taskDetails?.decomICP?.desktopQA?.fieldPhotosRequired}
                        desktopQABy={taskDetails?.decomICP?.desktopQABy}
                        desktopQAComments={taskDetails?.decomICP?.desktopQA?.desktopQAComments}
                        onClose={handleClose}
                    />
                </Card>

                <Divider sx={{mt: 12, mb: 6}} />

                <Typography variant="h6" color="secondary" paragraph>Desktop Assessment</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        {/* <Typography variant="body2">Comments</Typography> */}
                        <SmallLabelledText label="GIS Check Comments"                     text={taskDetails?.decomICP?.desktopChecklist?.gisCheckComments} />
                        <SmallLabelledText label="Google Maps Check Comments"             text={taskDetails?.decomICP?.desktopChecklist?.googleMapsCheckComments} />
                        <SmallLabelledText label="Decommissioning Records Check Comments" text={taskDetails?.decomICP?.desktopChecklist?.decommissioningRecordsCheckComments} />
                        <SmallLabelledText label="General Comments"                       text={taskDetails?.decomICP?.desktopChecklist?.generalComments} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* <Typography variant="body2">Images</Typography> */}
                        <UpdatedGalleryViewer documents={allImages} bffBase={bffBaseUrl} options={{readOnly: true}} />
                    </Grid>
                </Grid>

                <Box>
                    <DebugBox title="taskDetails" stringify>{taskDetails}</DebugBox>
                </Box>
            </LoadingBox>
        </Box>
    )
}
